import {
    Component,
    OnInit,
    ViewEncapsulation,
    ElementRef
} from '@angular/core';
import { Router } from '@angular/router';
import { DatatableComponent } from '../../../datatable.component';
import { SettingService } from '../../../../../../services/setting.service';

@Component({
    selector: 'app-list-setting',
    templateUrl: './list-setting.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ListSettingComponent extends DatatableComponent implements OnInit {
    updateTrigger() {
        this.router.navigate(['/owner/setting/update/' + this.id]);
    }
    deleteTrigger() { }

    buildDatatableParams() {
        this.columns = [
            {
                field: 'key',
                title: 'Key',
                template: function(row) {
                    return row.key;
                }
            },
            {
                field: 'value',
                title: 'Value',
                template: function(row) {
                    return row.value;
                }
            },
            {
                field: 'description',
                title: 'Description',
                template: function(row) {
                    return row.description;
                }
            },
            {
                field: 'Actions',
                width: 80,
                title: 'Actions',
                sortable: false,
                overflow: 'visible',
                textAlign: 'center',
                template: function(row, index, datatable) {
                    return (
                        '<button data-id="' +
                        row.key +
                        '" id="updateUser' +
                        row.key +
                        '" class="update-row m-datatable--on-layout-updated m-portlet__nav-link btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" title="Edit "><i class="la la-edit"></i></button>'
                    );
                }
            }
        ];
    }

    datatable: any;

    constructor(
        private settingService: SettingService,
        protected el: ElementRef,
        private router: Router
    ) {
        super(el);
    }

    ngOnInit() {
        this.datatableUrl = '/settings/list';
        this.buildDatatable();
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/owner/setting/list-setting/list-setting.component.ts